import UrbanProcesses from './component'

export default UrbanProcesses
